export enum CustomEvents {
    'TRANSPORT_STATE_CHANGED' = 'landr-samples-transport-state-changed',
    'SHOW_PRICING_MODAL' = 'landr-samples-show-pricing-modal',
    'SAMPLES_PURCHASE' = 'landr-samples-purchase',
    'CLIENT_UPDATE_REQUIRED' = 'landr-samples-client-update-required',
    'SHOW_POOR_STANDING_OR_SUSPENDED_MODAL' = 'landr-samples-show-poor-standing-or-suspended-modal',
    'LOGOUT' = 'landr-samples-logout',
}
